import { observable } from "mobx";
import Model from "@app/state/model/base";

export default class ReportDocument extends Model {
    @observable _id = undefined;
    @observable project = undefined;
    @observable client = undefined;
    @observable name = undefined;
    @observable status = undefined;
    // `aiGenerated` is set at creation, before any run exists — so it, and not
    // `cerRunId`, is what marks a document as AI-generated.
    @observable aiGenerated = undefined;
    @observable aiTemplate = undefined;
    @observable cerRunId = undefined;
    @observable cerGeneration = undefined;
    @observable comments = undefined;
    @observable header = undefined;
    @observable footer = undefined;
    @observable review = undefined;
    @observable reviewConfig = {
        stages: [],
    };
    @observable metaData = undefined;
}
